export default __webpack_public_path__ + "static/media/repoActive.178fe5b3.svg";